import React, { useState } from 'react';
import '../scss/button.scss';
import { ReactComponent as StarfinLogo } from '../images/stashfin-logo.svg'
import { ReactComponent as HomeIcon } from '../images/home.svg'
import { ReactComponent as CheckIcon } from '../images/check-red.svg'
import { ReactComponent as QuoteIcon } from '../images/quote.svg'
import { useNavigate } from 'react-router-dom';
import CenteredPopup from '../components/popups/CenteredPopup'
import PageHeader from '../components/PageHeader';
function Enach() {
    const [isModalOpen, setIsModalOpen] = useState(false);
    const handleOpen = () => {
        setIsModalOpen(true);
    }
    const handleClose = () => {
        setIsModalOpen(false);
    }
    const navigate = useNavigate()
    return (
        <div className='external-wrapper enach-page'>
            <div className='page-content pb-0'>
                <PageHeader />
                <div className='page-heading text-center'>
                    <h2 className='page-title'>eNACH</h2>
                </div>
                <div className='verify-content text-center'>
                    <HomeIcon className='enach-image' />
                    <p>Maximize your credit limit by placing standing instruction</p>
                    <ul>
                        <li><CheckIcon className='branding-icon' />No annoying reminder & late fees</li>
                        <li><CheckIcon className='branding-icon' />Auto debit of EMIs</li>
                        <li><CheckIcon className='branding-icon' />Healthy Credit Score</li>
                    </ul>
                </div>
                <ul className='bank-details'>
                    <li><span>Bank Name :</span><span>BankName</span></li>
                    <li><span>Account Number :</span><span>AccNo</span></li>
                    <li><span>IFSC Code :</span><span>ifsc</span></li>
                </ul>
            </div>
            <div className='bottom-footer'>
                <p className='know-enach'>Know more about <span className='red-text' onClick={handleOpen}>eNACH</span></p>
                <p className='powered-by'>Powered by <StarfinLogo /></p>
                <button type="submit" className="btn btn-primary" onClick={() => {
                    localStorage.setItem("lastVisitedPage", '/final-approval')
                    navigate('/final-approval')
                }}>Continue</button>
            </div>
            <CenteredPopup
                className="enach-modal"
                isOpen={isModalOpen}
                onClose={handleClose}>
                    <QuoteIcon className="quote" />
                    <h3>Know more about eNACH</h3>
                    <p>e-NACH stands for Electronic National Automated Clearing House and is a secure and convenient way to automate your EMI payments. With e-NACH, you authorize Stashfin to process your EMIs from your Bank on agreed upon dates.  This way you don't have to remember due dates and the payments can happen automatically on time!</p>
            </CenteredPopup>
        </div>
    );
}

export default Enach;
